import React from 'react';
import type { SupportedHtmlTags, Theme } from '../../../core/types';
import Element from '../../../core/Element';
import type { FontType } from '../../../core/enums';

/**
 * @deprecated
 * DEPRECATION NOTICE:
 * This component should not be used and will be removed [in V2](https://github.aexp.com/amex-eng/aqx-components/tree/next)
 *
 * Please migrate to Typography utility classes when possible
 */
export interface TypographyProps {
  Component?: keyof SupportedHtmlTags;
  children: React.ReactNode;
  className?: string;
  theme?: Theme;
  qeId?: string;
  $family?: FontType;
  $size?: number | string;
  $lineHeight?: number | string;
  tabIndex?: number;
  role?: string;
  forwardedRef?: any;
  id?: string;
}

const cssValueConverter = (cssValue: number | string) =>
  typeof cssValue === 'number' ? `${cssValue}px` : cssValue;

/**
 * @deprecated
 * DEPRECATION NOTICE:
 * This component should not be used and will be removed [in V2](https://github.aexp.com/amex-eng/aqx-components/tree/next)
 *
 * Please migrate to Typography utility classes when possible
 *
 * Ex: `<h1 className="text-heading-1">Heading 1</h1>`
 */
export const Typography = ({
  $family,
  $size,
  $lineHeight,
  theme = {},
  Component = 'p',
  ...props
}: TypographyProps) => (
  <Element
    {...props}
    Component={Component}
    theme={{
      fontType: $family,
      ...theme,
    }}
    style={{
      fontSize: $size ? cssValueConverter($size) : undefined,
      ...($lineHeight && { lineHeight: cssValueConverter($lineHeight) }),
    }}
  />
);
